import React from "react";
import { push } from "redux-first-history";
import { userSetupSlice } from "../../../../store/reducer/user_setup";
import Grid from "@mui/material/Grid";
import { ExitType } from "../../../../constants/common"
import { useDispatch } from "react-redux";
import { useCurrentTaxYear } from "../../../../hooks/TaxYear";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomRadio from "../../../../components/CustomRadio";

const AgeVerification = () => {
  const dispatch = useDispatch();
  const currentTaxYear = useCurrentTaxYear();

  return <Grid className="radio-group-row" size={12}>
      <FormLabel
        id="age-verification-radio-label"
        className="radio-group-label bold"
        htmlFor="age-verification-radio"
      >
        Were you 18 years of age or older for all of { currentTaxYear }?
      </FormLabel>

      <RadioGroup
        aria-labelledby="age-verification-radio-label"
        name="age-verification-radio"
        defaultValue={null}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const isAnAdult = e.target.value === "true";

          if (isAnAdult) {
            dispatch(push('/register/email'));
          } else {
            dispatch(userSetupSlice.actions.setExitMessageType(ExitType.UserIsAMinor));
            dispatch(push('/register/sorry'));
          }
        }}
      >
        <FormControlLabel
          label="YES"
          value="true"
          control={<CustomRadio />}
        />
        <FormControlLabel
          label="NO"
          value="false"
          control={<CustomRadio />}
        />
      </RadioGroup>
  </Grid>
};

export default AgeVerification;
